<div *ngIf="gaugeObject?.error" class="subtitle-1 text-center text-danger w-100 pt-3">{{ gaugeObject.error }}</div>
<div [hidden]="gaugeObject?.error || isNoMetric || isDateRangeTooWideIntraday" class="gauge-container lato-regular h-100 w-100" #gaugeContainer></div>
<!-- Error Views -->
<app-module-error *ngIf="isNoMetric" [noMetric]="true"></app-module-error>
<app-module-error *ngIf="isDateRangeTooWideIntraday" [dateRangeTooWideIntraday]="true"></app-module-error>

<span [id]="'min-max-modal-container-'+moduleKey"></span>

<ng-template #minMaxModal>
    <div class="modal-header">
        <div class="modal-title bolded-text font-size-20" cvLocalizedText langSection="Gauge_Min_Max" langKey="Gauge_Range">Gauge Range</div>
        <!-- Close button -->
        <div class="position-absolute" style="top: 8px; right: 8px;">
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="closeModal()">
                <svg class="icon-16"><use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
            </button>
        </div>
    </div>
    <div class="modal-body">
        <div class="title-text mb-3" 
            cvLocalizedText langSection="Gauge_Min_Max" langKey="Min_Max_Visualization">
            Add Min and Max values for better data visualization.
        </div>
        <div class="min-max-inputs" [ngClass]="[minMaxForm.get('maxValue').errors || minMaxForm.get('minValue').errors ? 'min-max-inputs-error' : '']" [formGroup]="minMaxForm">
            <div class="min-input">
                <label for="min" class="labels" cvLocalizedText langSection="Gauge_Min_Max" langKey="Min">Min</label>
                <input class="form-control form-control-lg"
                    [ngClass]="[minMaxForm.get('minValue').errors ? 'error-border': '']"
                    (blur)="formatFormTimeValues('minValue')"
                    autocomplete="off"
                    type="text"
                    name="min"
                    id="min" 
                    [placeholder]="defaultMin" 
                    maxlength="8"
                    formControlName="minValue">
            </div>
            <div class="max-input">
                <label for="Max" class="labels" cvLocalizedText langSection="Gauge_Min_Max" langKey="Max">Max</label>
                <input class="form-control form-control-lg"
                    [ngClass]="[minMaxForm.get('maxValue').errors ? 'error-border': '']"
                    (blur)="formatFormTimeValues('maxValue')"
                    autocomplete="off"
                    type="text"
                    name="max" 
                    id="max" 
                    [placeholder]="defaultMax" 
                    maxlength="10"
                    formControlName="maxValue">
            </div>
            <button class="btn btn-text ml-3"
                type="button"
                [disabled]="!minMaxForm.get('minValue').value && !minMaxForm.get('maxValue').value" 
                (click)="resetMinMax()"
                cvLocalizedText langSection="Gauge_Min_Max" langKey="Reset">Reset to Default
            </button>
        </div>
        <!-- Min error message -->
        <div class="error-message" *ngIf="displayError(minMaxForm.controls['minValue'])">
            <svg class="icon-16 fill-redRyder"><use href="../../App_Themes/clearview-default/icons/utility/info.svg#info"></use></svg>
            <span style="margin-left: 0.3rem;">{{ getErrorMessage(minMaxForm.controls['minValue']) }}</span>
        </div>
        <!-- Max error message -->
        <div class="error-message" *ngIf="displayError(minMaxForm.controls['maxValue'])">
            <svg class="icon-16 fill-redRyder"><use href="../../App_Themes/clearview-default/icons/utility/info.svg#info"></use></svg>
            <span style="margin-left: 0.3rem;">{{ getErrorMessage(minMaxForm.controls['maxValue']) }}</span>
        </div>
        <div class="objective-container">
            <div class="title-text bolded-text" cvLocalizedText langSection="Gauge_Min_Max" langKey="Objectives">Objectives</div>
            <div class="mb-3 sub-title-text">{{ metricName }}: {{ range }} 
                <span cvLocalizedText langSection="Gauge_Min_Max" langKey="Ranges">Ranges</span>
            </div>
            <div class="objectives">
                <div class="duration">{{ selectedDateText }}</div>
                <div class="d-flex">
                <div *ngFor="let obj of objectiveData | keyvalue">
                    <div class="breakpoint"><span [ngClass]="obj.value[0]"></span>{{ obj.value[1] }}</div>
                </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" 
            class="btn modal-footer-btn btn-text" (click)="closeModal()" 
            cvLocalizedText langSection="Common" langKey="Cancel_Button">
            Cancel
        </button>
        <button type="button" class="btn modal-footer-btn btn-primary" 
            [disabled]="!minMaxChanged() || minMaxForm.get('maxValue').errors || minMaxForm.get('minValue').errors" 
            (click)="saveMinMax(minMaxForm.get('minValue').value, minMaxForm.get('maxValue').value)"
            cvLocalizedText langSection="Common" langKey="Save_Button">
            Save
        </button>
    </div>
</ng-template>